import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { plainToClass } from 'class-transformer';
import { Observable, catchError, map, of } from 'rxjs';

import { ResearchType } from '@empathy/global/data';
import { Question } from '@empathy/survey-core';

import { EnvironmentConfig } from '../config/environment.config';

@Injectable({ providedIn: 'root' })
export class QuestionsLibraryService {
  constructor(
    @Inject('environment') private environment: EnvironmentConfig,
    private http: HttpClient
  ) {}

  fetchLibrary(): Observable<Question[]> {
    return this.http
      .get<{ id: string; typeId: number; questionJson: string }[]>(`${this.environment.endPoint}library/questions?typeId=${ResearchType.Survey}`)
      .pipe(
        map((response) =>
          response.map((q) => {
            const question = plainToClass(Question, JSON.parse(q.questionJson));
            question.id = q.id;
            return question;
          })
        ),
        catchError(() => of([]))
      );
  }

  saveQuestion(question: Question): Observable<boolean> {
    return this.http
      .post<Question>(`${this.environment.endPoint}library/questions`, { type: ResearchType.Survey, questionJson: this.cleanQuestionToSave(question) })
      .pipe(
        map(() => true),
        catchError(() => of(false))
      );
  }

  deleteQuestion(id: string): Observable<boolean> {
    return this.http.delete<boolean>(`${this.environment.endPoint}library/questions/${id}`).pipe(catchError(() => of(false)));
  }

  private cleanQuestionToSave(question: Question): string {
    question.id = null;
    question.pageId = null;
    question.visibleWhen = null;
    question.cards?.forEach((card) => (card.visibleWhen = null));
    question.options?.forEach((option) => (option.visibleWhen = null));

    return JSON.stringify(question);
  }
}
